{
  "title": "Opret events fra skabelon",
  "description": "Opret enkelt-dages events fra skabelon",
  "pages": [
    {
      "name": "page_copy",
      "title": "Event-detaljer",
      "description": "Tilpas beskrivelse og tilføj datoer. Lokation kan udelades for at bruge skabelonens standard.",
      "elements": [
        {
          "type": "text",
          "name": "short_description",
          "title": "Kort beskrivelse",
          "description": "Til visning i kalender som titel",
          "isRequired": true
        },
        {
          "type": "comment",
          "name": "description",
          "title": "Beskrivelse",
          "isRequired": true
        },
        {
          "type": "paneldynamic",
          "name": "copy_instances",
          "title": "Events der skal oprettes",
          "templateElements": [
            {
              "type": "text",
              "name": "copy_start_date",
              "width": "100%",
              "startWithNewLine": true,
              "title": "Dato og tidspunkt",
              "isRequired": true,
              "inputType": "datetime-local",
              "defaultDateTime": "12:00"
            },
            {
              "type": "text",
              "name": "copy_end_time",
              "width": "100%",
              "startWithNewLine": true,
              "title": "Sluttidspunkt",
              "isRequired": true,
              "inputType": "time",
              "defaultValue": "13:00"
            },
            {
              "type": "dropdown",
              "name": "sub_event_location",
              "title": "Lokation (valgfri – bruger skabelonens standard hvis tom)",
              "dataSource": "locations",
              "dataSourceKeyField": "locations_name",
              "dataSourceValueField": "guid",
              "mergeWithStaticChoices": true,
              "onChangeUpdateQuestion": "sub_event_room",
              "choices": [{ "value": "manual", "text": "Manuel" }]
            },
            {
              "type": "dropdown",
              "name": "sub_event_room",
              "visibleIf": "{panel.sub_event_location} notempty and {panel.sub_event_location} <> 'manual'",
              "title": "Lokale",
              "dataSource": "locations_rooms",
              "dataSourceKeyField": "room_name",
              "dataSourceValueField": "guid"
            },
            {
              "type": "text",
              "name": "sub_event_manual_location",
              "visibleIf": "{panel.sub_event_location} = 'manual'",
              "title": "Manuel lokation - Navn",
              "requiredIf": "{panel.sub_event_location} = 'manual'",
              "isRequired": false
            },
            {
              "type": "text",
              "name": "sub_event_manual_location_address",
              "visibleIf": "{panel.sub_event_location} = 'manual'",
              "title": "Manuel lokation - Adresse",
              "requiredIf": "{panel.sub_event_location} = 'manual'",
              "isRequired": false
            },
            {
              "type": "text",
              "name": "sub_event_manual_room_capacity",
              "visibleIf": "{panel.sub_event_location} notempty",
              "title": "Manuel lokale - Antal",
              "description": "Påkrævet hvis intet lokale valgt",
              "requiredIf": "{panel.sub_event_location} notempty and {panel.sub_event_room} empty",
              "inputType": "number"
            }
          ],
          "templateTitle": "Event {panelIndex}",
          "addPanelText": "Tilføj dato",
          "removePanelText": "Slet dato",
          "minPanelCount": 1,
          "maxPanelCount": 50
        }
      ]
    }
  ],
  "navigationButtonsLocation": "topBottom",
  "showTitle": false,
  "showCompletePage": false,
  "checkErrorsMode": "onValueChanged",
  "showEmptyFormSubmit": false
}
